import isBot from 'isbot';

export const isBotAgent = () => {
  const { userAgent } = typeof window !== 'undefined' ? window.navigator : {};
  return isBot(userAgent);
};
